<template>
  <div class="return-goods">
    <div class="table-wrapper">
      <div class="header">
          <el-form ref="form" :model="form" label-width="100px">
            <el-row>
<!--              <el-col :span="6">-->
<!--                <el-form-item label="订单号">-->
<!--                  <el-input v-model="form.subOrderNo" placeholder="可输入子单号查询"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
              <el-col :span="6" v-if="activeSubTab === 1">
                <el-form-item label="结算单号">
                  <el-input v-model="form.settleNo" placeholder="请输入结算单号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否拆分扣款" v-if="redBlueOffset">
                  <el-select v-model="form.hasDeducted" size="small" clearable placeholder="请选择">
                    <el-option
                      label="是"
                      :value="1">
                    </el-option>
                    <el-option
                      label="否"
                      :value="0">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="售后单号">
                  <el-input v-model="form.afterSaleOrderNo" placeholder="请输入售后单号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="售后确认日期">
                  <el-date-picker
                    v-model="form.date"
                    :clearable="false"
                    unlink-panels
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="handleRangePickerChange"
                    size="small">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button class="btn default-btn" style="margin-left:100px" @click="exportData">导出</el-button>
                <el-button type="primary" @click="onSubmit" class="btn">搜索</el-button>
                <el-button class="btn default-btn" @click="resetData">重置</el-button>
              </el-col>
            </el-row>
          </el-form>
      </div>
      <tabs :tabList="subTabList" :activeTab="activeSubTab" :changeTab="changeTab"/>
<!--      已扣款-->
      <div v-show="activeSubTab === 1">
        <!-- 表格-->
        <el-table
          :data="refundTableData"
          :max-height="300"
          style="width: 100%"
          @expand-change="expandChange"
        >
          <el-table-column
            type="expand"
            width="55"
          >
            <template slot-scope="props">
              <!--内嵌表格-->
              <el-table :data="props.row.child">
                <el-table-column
                  label="序号"
                  prop="serialNum"
                >
                </el-table-column>
                <el-table-column
                  label="结算单号"
                  prop="settleNo"
                >
                </el-table-column>
                <el-table-column
                  label="扣款数量"
                  prop="deductedCount"
                >
                </el-table-column>
                <el-table-column
                  label="单价"
                  prop="price"
                >
                </el-table-column>
                <el-table-column
                  label="扣款总额"
                  prop="totalAmount"
                >
                </el-table-column>
                <el-table-column
                  label="售后扣款时间"
                  prop="deductedTime"
                >
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column
            label="序号"
            width="120"
            prop="serialNum"
          >
          </el-table-column>
          <el-table-column
            prop="afterSaleConfirmDate"
            label="售后确认日期"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="afterSaleOrderNo"
            label="售后单号"
            width="120"
          >
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="saleOrderNo"-->
<!--            label="销售单号"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
            prop="skuCode"
            label="商品编码"
            width="120">
          </el-table-column>
          <el-table-column
            prop="skuName"
            label="商品名称"
            width="120">
          </el-table-column>
          <el-table-column
            prop="afterSaleConfirmQuantity"
            label="售后确认数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="price"
            label="采购单价"
            width="120">
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="售后总金额"
            width="120">
          </el-table-column>
          <el-table-column
            prop="unSettledQuantity"
            label="结余"
            width="120">
          </el-table-column>
          <el-table-column
            prop="refundStatus"
            label="状态"
            width="120">
          </el-table-column>
          <el-table-column
            prop="isSplit"
            label="是否拆分扣款"
            width="120">
            <template slot-scope="scope">
              <span>{{scope.row.isSplit === 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
<!--      未扣款-->
      <div v-show="activeSubTab === 2">
        <!-- 表格-->
        <el-table
          :data="unRefundTableData"
          :max-height="300"
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            width="120"
            prop="serialNum"
          >
          </el-table-column>
          <el-table-column
            prop="afterSaleConfirmDate"
            label="售后确认日期"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="afterSaleOrderNo"
            label="售后单号"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isSplit === 1" @click="goOriginalOrder(scope.row.afterSaleOrderNo);" style="color: #236BDC; cursor: pointer">{{scope.row.afterSaleOrderNo}}</span>
              <span v-if="scope.row.isSplit === 0">{{scope.row.afterSaleOrderNo}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            prop="saleOrderNo"-->
<!--            label="销售单号"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
            prop="skuCode"
            label="商品编码"
            width="120">
          </el-table-column>
          <el-table-column
            prop="skuName"
            label="商品名称"
            width="120">
          </el-table-column>
          <el-table-column
            prop="afterSaleConfirmQuantity"
            label="售后确认数量"
            width="120">
          </el-table-column>
          <el-table-column
            prop="price"
            label="采购单价"
            width="120">
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="售后总金额"
            width="120">
          </el-table-column>
          <el-table-column
            prop="unSettledQuantity"
            label="结余"
            width="120">
          </el-table-column>
          <el-table-column
            prop="refundStatus"
            label="状态"
            width="120">
          </el-table-column>
          <el-table-column
            prop="isSplit"
            label="是否拆分扣款"
            width="120">
            <template slot-scope="scope">
              <span>{{scope.row.isSplit === 1 ? '是' : '否'}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <!-- 查看原单弹窗-->
    <el-dialog
      class="settle-modal"
      :visible.sync="orderDialogVisible"
      width="80%"
      :append-to-body="true"
    >
       <span slot="title" class="dialog-title">
        <span class="title">查看原单</span>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose('originOrderModal')">确认</el-button>
      </span>
      <el-table
        :data="originalOrderList"
        border
        height="100"
        style="width: 100%; margin-top: 20px">
        <el-table-column
          prop="id"
          label="原单"
          width="180">
        </el-table-column>
        <el-table-column
          prop="confirmDate"
          label="售后确认日期">
        </el-table-column>
        <el-table-column
          prop="saleOrder"
          label="售后单号">
        </el-table-column>
        <el-table-column
          prop="skuCode"
          label="商品编码">
        </el-table-column>
        <el-table-column
          prop="skuName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          prop="originalQuantity"
          label="原数量">
        </el-table-column>
        <el-table-column
          prop="unDeductQuantity"
          label="待抵扣数量">
        </el-table-column>
        <el-table-column
          prop="purchasePrice"
          label="采购单价">
        </el-table-column>
        <el-table-column
          prop="originalTotalAmount"
          label="原总价">
        </el-table-column>
        <el-table-column
          prop="unDeductTotalAmount"
          label="待抵扣总价">
        </el-table-column>
      </el-table>
      <el-table
        :data="deductionOrderList"
        border
        height="100"
        style="width: 100%; margin-top: 20px">
        <el-table-column
          prop="id"
          label="抵扣单"
          width="180">
        </el-table-column>
        <el-table-column
          prop="confirmTime"
          label="结算单确认日期">
        </el-table-column>
        <el-table-column
          prop="settleNo"
          label="结算单">
        </el-table-column>
        <el-table-column
          prop="amount2"
        >
        </el-table-column>
        <el-table-column
          prop="amount2"
        >
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="扣款数量">
        </el-table-column>
        <el-table-column
          prop="purchasePrice"
          label="采购单价">
        </el-table-column>
        <el-table-column
          prop="purchaseTotalAmount"
          label="扣款总价">
        </el-table-column>
        <el-table-column
          prop="status"
          label="抵扣状态">
          <template slot-scope="scope">
            <span>{{scope.row.status | filterStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="settleDate"
          label="实际抵扣日期">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Tabs from "@/components/tabs/tabs";
import {
  queryDeductedRefund,
  queryDeductedRefundDetail,
  queryUnDeductedRefundDetail
} from "../../../../models/r4ReportModel";
import r4ReportApiList from "../../../../service/basic/r4ReportApiList";
import {doOriginalOrder, doRedBlueOffset} from "../../../../models/r4SettleModel";
import moment from "moment";
import {buildURL} from "../../../../utils/utils";
export default {
  components: {
    Tabs
  },
   data() {
     return {
       redBlueOffset: true, // 红蓝相抵的供应商才显示
       form: {
         subOrderNo: '',
         settleNo: '',
         hasDeducted: '',
         date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         afterSaleOrderNo: ''
       },
       pickerOptions: {
         disabledDate (current) {
           return current && (current > moment().endOf('day') || current < moment().subtract(3, 'months'))
         }
       },
       pageSize: 10,
       page: 1,
       refundTableData: [],
       loading: false,
       activeSubTab: 1,
       subTabList: [
         {
           id: 1,
           name: '已扣款'
         },
         {
           id: 2,
           name: '未扣款'
         }
       ],
       totalCount:0,
       detailTableData: [],
       unRefundTableData: [],
       orderDialogVisible: false,
       originalOrderList: [],
       deductionOrderList: [],
     }
   },
  created() {
    this.loadRedBlueOffset();
    this.loadDeductedRefund();
  },
  filters: {
    filterStatus (val) {
      let text = ''
      switch (val) {
        case 2:
          text = '已抵扣'
          break
        case 1:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          text = '未抵扣'
          break
        default:
          break
      }
      return text
    }
  },
  methods: {
    // 判断供应商是否支持红蓝相抵
    loadRedBlueOffset() {
      doRedBlueOffset({supplierId: localStorage.getItem('supplier_id'),}).then((res) => {
        this.redBlueOffset = res;
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 查看原单
    goOriginalOrder(orderNumber) {
      doOriginalOrder({orderNumber}).then((res) => {
        this.originalOrderList = [{
          "confirmDate": res.confirmDate,
          "originalQuantity": res.originalQuantity,
          "originalTotalAmount": res.originalTotalAmount,
          "purchasePrice": res.purchasePrice,
          "saleOrder": res.saleOrder,
          "skuCode": res.skuCode,
          "skuName": res.skuName,
          "unDeductQuantity": res.unDeductQuantity,
          "unDeductTotalAmount": res.unDeductTotalAmount
        }];
        this.deductionOrderList = res.deductionOrder || [];
        this.orderDialogVisible = true;
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
    // 关闭弹窗
    handleClose() {
      this.orderDialogVisible=false;
    },
    // 获取未扣款列表
    loadUnDeductedRefundDetail() {
      queryUnDeductedRefundDetail({
        supplierId: localStorage.getItem('supplier_id'),
        page: this.page - 1,
        pageSize: this.pageSize,
        settleNo: this.form.settleNo,
        subOrderNo: this.form.subOrderNo,
        startDate: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
        endDate: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
        afterSaleOrderNo: this.form.afterSaleOrderNo,
        isSplit: this.form.hasDeducted,
      }).then(res => {
        this.unRefundTableData = res ? res.content.map((item, index) => {
          item.serialNum = index + 1 + (this.page - 1) * this.pageSize;
          return item;
        }) : []
        this.totalCount = res ? Number(res.totalElements) : 0;
      }).catch((err) => {
        console.log(err);
        this.$message.error(err.message);
      });
    },
     // 获取已退货列表
     loadDeductedRefund() {
       this.activeSubTab = 1;
       queryDeductedRefund({
         supplierId: localStorage.getItem('supplier_id'),
         page: this.page - 1,
         pageSize: this.pageSize,
         settleNo: this.form.settleNo,
         subOrderNo: this.form.subOrderNo,
         startDate: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
         endDate: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
         afterSaleOrderNo: this.form.afterSaleOrderNo,
         isSplit: this.form.hasDeducted,
       }).then(res => {
         this.refundTableData = res ? res.content.map((item, index) => {
           item.serialNum = index + 1 + (this.page - 1) * this.pageSize;
           item.child = [] // 先给一个空值
           item.expand = false  // 表示当前行是闭合的，不设置这个等下展开后就没法闭合了
           return item;
         }) : []
         this.totalCount = res ? Number(res.totalElements) : 0;
       }).catch((err) => {
         console.log(err);
         this.$message.error(err.message);
       });
     },
    handleRangePickerChange(value) {
      console.log(value, "value", moment(value[1]).subtract(3, "months").isBefore(moment(value[0])));
      if (!moment(value[1]).subtract(3, "months").isBefore(moment(value[0]))) {
        this.$message.error("选择的时间跨度最大为3个月");
        this.form.date = [moment(value[1]).subtract(3, "months").format('YYYY-MM-DD'), moment(value[1]).format('YYYY-MM-DD')];
      } else {
        this.form.date = value;
      }
    },
     changeTab(type) {
       this.activeSubTab = type;
       this.page = 1;
       this.pageSize=10;
       this.form = {
         subOrderNo: '',
         settleNo: '',
         hasDeducted: '',
         date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
         afterSaleOrderNo: ''
       }
       if (this.activeSubTab === 1) {
         this.loadDeductedRefund();
       } else {
         this.loadUnDeductedRefundDetail();
       }
     },
     onSubmit() {
        if (this.activeSubTab === 1) { // 已扣款
          this.loadDeductedRefund();
        } else {
          this.loadUnDeductedRefundDetail();
        }
     },
      resetData() {
        this.page = 1;
        this.pageSize=10;
        this.form = {
          subOrderNo: '',
          settleNo: '',
          hasDeducted: '',
          date: [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
          afterSaleOrderNo: ''
        }
        if (this.activeSubTab === 1) {
          this.loadDeductedRefund();
        } else {
          this.loadUnDeductedRefundDetail();
        }
      },
     handleSizeChange (val) {
       this.pageSize = val
       if (this.activeSubTab === 1) {
         this.loadDeductedRefund();
       } else {
         this.loadUnDeductedRefundDetail();
       }
     },
     handleCurrentChange (val) {
       this.page = val
       if (this.activeSubTab === 1) {
         this.loadDeductedRefund();
       } else {
         this.loadUnDeductedRefundDetail();
       }
     },
      //展开
      expandChange (row, expandedRows) {
        console.log(row, expandedRows);
        if (!row.expand) {  // 先判断该行是否已经展开了
          this.loadDetail(row);
        } else {
          row.expand = false;
        }
      },
      // 获取已支付结算单明细
      loadDetail(row) {
        queryDeductedRefundDetail({
          asOrderNumber: row.afterSaleOrderNo,
        }).then(res => {
          row.expand = false
         row.child = res ? res.map((item, index) => {
            item.serialNum = index + 1 + (this.page - 1) * this.pageSize;
            return item;
          }) : [];
        }).catch((err) => {
          console.log(err);
          this.$message.error(err.message);
        });
      },
      // 导出
      exportData() {
        if (this.activeSubTab === 1) { // 已扣款
          const params = {
            subOrderNo: this.form.subOrderNo,
            hasDeducted: this.form.hasDeducted,
            settleNo: this.form.settleNo,
            startDate: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
            endDate: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
            supplierId: localStorage.getItem('supplier_id'),
            afterSaleOrderNo: this.form.afterSaleOrderNo
          }
          window.open(`${myhostname}${r4ReportApiList.exportDeductedRefundDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
        } else {
          const params = {
            subOrderNo: this.form.subOrderNo,
            hasDeducted: this.form.hasDeducted,
            startDate: this.form.date ? this.form.date[0] + ' 00:00:00' : '',
            endDate: this.form.date ? this.form.date[1] + ' 23:59:59' : '',
            supplierId: localStorage.getItem('supplier_id'),
            afterSaleOrderNo: this.form.afterSaleOrderNo
          }
          window.open(`${myhostname}${r4ReportApiList.exportUnDeductedRefundDetail}?${buildURL(params)}&access_token=${localStorage.getItem('token')}`);
        }
      }
   }
}
</script>

<style lang="scss" scoped>
.return-goods {
  width: 100%;
  padding: 10px;
  background: #fff;
  .el-input__inner {
    width: 100% !important;
  }
  .el-icon-date:before {
    top:0;
  }
  .btn {
    width: 70px;
    height: 30px;
    background: linear-gradient(132deg, #FF602F 0%, #FF3722 100%, #FF3621 100%, #FF3621 100%, #FF3722 100%);
    border-radius: 6px;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 0;
    line-height: 30px;
    margin-top: 5px;
  }

  .default-btn {
    background: #fff;
    font-size: 8px;
    font-family: MicrosoftYaHei;
    color: #666666;
    border-radius: 6px;
    border: 1px solid #D5D5D5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/summaryReport/components/returnGoodsList.vue